import type { FC } from 'react'

import type { PhoneBookType } from '../types'

import { PhoneBookItem } from './PhoneBookItem'

type IProps = {
  item: PhoneBookType
  selectedItem: PhoneBookType
  onClick: (item: PhoneBookType) => void
  searchPhrase: string
}

export const PhoneBookItems: FC<IProps> = ({ item, selectedItem, onClick, searchPhrase }) => (
  <div>
    <PhoneBookItem
      item={item}
      isSelected={item.id === selectedItem?.id && item.type === selectedItem?.type}
      onClick={onClick}
      searchPhrase=""
    />
    {item.children && (
      <div>
        {/* We spread the map here because datatype Map does not have a .map function like Arrays */}
        {[...item.children].map(([, child]) => {
          if (child.name.toLowerCase().includes(searchPhrase))
            return (
              <div key={child.id} className="pl-3 md:pl-5 lg:pl-3">
                <PhoneBookItem
                  item={child}
                  isSelected={child.id === selectedItem?.id && child.type === selectedItem?.type}
                  onClick={onClick}
                  searchPhrase={searchPhrase}
                />
              </div>
            )
          return null
        })}
      </div>
    )}
  </div>
)
